// extracted by mini-css-extract-plugin
export default {"pageWrapper":"PageWrapper_pageWrapper__oPLoJ","logedOutWrapepr":"PageWrapper_logedOutWrapepr__w-EGI"};